/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import styles from './index.module.css';
import { Modal } from 'react-responsive-modal';
import { FormattedMessage } from 'react-intl';
import 'react-responsive-modal/styles.css';

export function Speaker(props) {
  const { info, setFocusIndex, index } = props;
  const [open, setOpen] = useState(false);
  const myRef = React.useRef(null);

  return (
    <>
      <div ref={myRef} />
      <div
        style={{
          background: '#41b3ce no-repeat',
          backgroundSize: '100% 100%',
          backgroundImage: `url("${info.image}")`
        }}
        onMouseOver={() => setFocusIndex(index)}
        onMouseLeave={() => setFocusIndex(null)}
        onClick={onOpenModal}
        className={styles.avatar}>
        {info.name && (
          <div className={styles.description}>
            <div className={styles.descriptionContent}>
              <div className={styles.name}>{info.name}</div>
              <div className={styles.date}>
                {info.date} | {info.subject}
              </div>
            </div>
          </div>
        )}
      </div>

      {info.name && (
        <Modal
          open={open}
          onClose={onClose}
          center={true}
          container={myRef.current}>
          <div className={styles.responsive}>
            <div className={styles.title}>
              <img src={info.image} />
              <div className={styles.titleInformations}>
                <div className={styles.titleName}>{info.name}</div>
                <div className={styles.titleDate}>
                  {info.date} | {info.subject}
                </div>
              </div>
            </div>
            <div className={styles.titleDescription}>
              <div>{info.description}</div>
              {info.webPage ? (
                <div>
                  <a
                    href={info.webPage}
                    target="view_window"
                    style={{
                      textDecoration: 'none',
                      cursor: 'pointer',
                      fontSize: '24px',
                      fontWeight: 'bold',
                      color: 'rgb(114, 151, 193)'
                    }}>
                    <FormattedMessage id="Webpage" />
                  </a>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </Modal>
      )}
    </>
  );

  function onOpenModal() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }
}
